import { Stethoscope } from "@tamagui/lucide-icons";
import { forwardRef } from "react";
import { type TamaguiElement, getTokenValue } from "tamagui";

import { Button } from "./Button";

type TalkToDoctorButtonProps = {
  onPress: () => void;
  disabled?: boolean;
};

const TalkToDoctorButton = forwardRef<TamaguiElement, TalkToDoctorButtonProps>(
  ({ onPress, disabled, ...rest }, ref) => {
    return (
      <Button.Wrapper
        ref={ref}
        onPress={onPress}
        borderRadius="$100"
        padding="$50"
        backgroundColor="transparent"
        marginVertical="$100"
        disabled={disabled}
        opacity={disabled ? 0.5 : 1}
        cursor={disabled ? "not-allowed" : "pointer"}
        pointerEvents={disabled ? "none" : "auto"}
        dataTrackingId="talk-to-doctor-button"
        aria-label="Talk to doctor"
        {...rest}
      >
        <Stethoscope
          size={getTokenValue("$250")}
          color="$iconBase"
          flexShrink={0}
        />
      </Button.Wrapper>
    );
  },
);

TalkToDoctorButton.displayName = "TalkToDoctorButton";

export default TalkToDoctorButton;
